import React from 'react';
import { PageLayout } from '../../components/PageLayout';
import { HeaderBanner } from './HeaderBanner';
import { CertificationNotice } from './CertificationNotice';
import { KeyHighlights } from './KeyHighlights';
import { PrerequisiteWarning } from './PrerequisiteWarning';
import { RegistrationCallout } from './RegistrationCallout';
import { CourseGoal } from './CourseGoal';
import { CourseOverview } from './CourseOverview';
import { WhatToBring } from './WhatToBring';
import { CourseCosts } from './CourseCosts';
import { ContactSection } from './ContactSection';
import { QuickLinks } from './QuickLinks';
export function CPLCoursePage() {
  return <PageLayout data-id="element-1000">
      <HeaderBanner data-id="element-1001" />
      <CertificationNotice data-id="element-1002" />
      <KeyHighlights data-id="element-1003" />
      <PrerequisiteWarning data-id="element-1004" />
      <RegistrationCallout data-id="element-1005" />
      <CourseGoal data-id="element-1006" />
      <CourseOverview data-id="element-1007" />
      <WhatToBring data-id="element-1008" />
      <CourseCosts data-id="element-1009" />
      <ContactSection data-id="element-1010" />
      <QuickLinks data-id="element-1011" />
    </PageLayout>;
}